// @flow

export const getBidFromUrl = (url: string) => {
  const bid = url.match(RegExp("(manage\\/|account\\/bookings\\/)(\\d+)"))
  return bid ? bid[2] : ""
}
